import { render, staticRenderFns } from "./_tags.vue?vue&type=template&id=2099d21c&"
import script from "./_tags.vue?vue&type=script&lang=js&"
export * from "./_tags.vue?vue&type=script&lang=js&"
import style0 from "./_tags.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports